import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";

import {
  Content,
  MyAccount,
  Subscriptions,
  SectionHelp,
  SectionVideos,
  SectionAbout
} from "../../components";

const containerStyle = {
  backgroundColor: "#fff",
  padding: "24px 16px",
  borderRadius: "4px",
  margin: "8px"
};

const Home = ({ email, appsAPI, name, picture }) => (
  <div>
    <Content>
      <div>
        <Row gutter={0}>
          <Col md={16}>
            <Subscriptions style={containerStyle} appsAPI={appsAPI} />
          </Col>
          <Col md={8}>
            <MyAccount
              style={containerStyle}
              email={email}
              appsAPI={appsAPI}
              name={name}
              picture={picture}
            />
            <SectionHelp style={containerStyle} />
            <SectionVideos style={containerStyle} />
            <SectionAbout style={containerStyle} />
          </Col>
        </Row>
      </div>
    </Content>
  </div>
);

Home.propTypes = {
  email: PropTypes.string.isRequired,
  appsAPI: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  picture: PropTypes.string.isRequired
};

export default Home;



// WEBPACK FOOTER //
// ./src/views/home/Home.jsx